export default __webpack_public_path__ + "static/media/c8a463d07d89adf27ec6075e783bae91.gif";